import request from '@/config/axios'

/** 入企申请状态：0待审 1通过 2驳回 3待企业入驻 4已撤销 */
export type CompanyJoinApplyStatus = 0 | 1 | 2 | 3 | 4

/** 审核人类型：owner 企业管理员 / admin 平台代审 / system 系统自动 */
export type AuditSource = 'owner' | 'admin' | 'system'

/** 轨迹业务类型：entry 企业入驻 / join 入企申请 / member 成员变更 */
export type AuditTraceBizType = 'entry' | 'join' | 'member'

export interface CompanyJoinApplyVO {
  id?: string
  /** 公司账号 ID；占位申请为空（企业尚未入驻） */
  companyId?: string
  companyName?: string
  userId?: string
  userName?: string
  userAvatar?: string
  userPosition?: string
  reason?: string
  status?: CompanyJoinApplyStatus
  auditRemark?: string
  auditUserId?: string
  auditUserName?: string
  auditSource?: AuditSource
  /** 应审核的企业主体；为空表示无人可审 */
  ownerUserId?: string
  ownerName?: string
  /** 0启用 1停用；占位申请为空 */
  companyStatus?: number
  createTime?: string
  auditTime?: string
}

export interface CompanyJoinAuditReqVO {
  id: string
  /** 1通过 2驳回 */
  auditStatus: 1 | 2
  /** 驳回必填 */
  auditRemark?: string
  /** 占位申请通过时必须指定已入驻企业 */
  companyId?: string
}

export interface CompanyAuditTraceVO {
  bizType?: AuditTraceBizType
  /** 该行状态使用的字典类型 */
  statusDictType?: string
  bizId?: string
  companyId?: string
  companyName?: string
  actorUserId?: string
  actorName?: string
  mobile?: string
  status?: string
  remark?: string
  operatorUserId?: string
  operatorName?: string
  operatorSource?: AuditSource
  bizTime?: string
}

export const getCompanyJoinApplyPage = (params: {
  pageNo: number
  pageSize: number
  companyId?: string
  companyName?: string
  status?: number
  userId?: string
  auditSource?: string
}) => request.get({ url: '/bosscircle/company-join-apply/page', params })

export const auditCompanyJoinApply = (data: CompanyJoinAuditReqVO) =>
  request.put({ url: '/bosscircle/company-join-apply/audit', data })

export const getCompanyAuditTrace = (params: { companyId?: string; companyName?: string }) =>
  request.get({ url: '/bosscircle/company-join-apply/trace', params })
